import { ref as $ref, atom as $atom } from '@graphistry/falcor-json-graph';
import { createLogger } from '@graphistry/common/logger';
import { uuidv4 } from '@graphistry/node-util/uuid';
const logger = createLogger(__filename);

import { opt } from './views';

function decodeUrlEncodedObj(str, logPrefix) {
    try {
        if (!str) {
            return null;
        }
        logger.debug({[logPrefix]: str}, logPrefix);
        
        try {
            const decoded = decodeURIComponent(str);
            logger.debug({decoded}, 'decoded');
            return JSON.parse(decoded);
        } catch (e) {
            logger.debug({[logPrefix]: str}, logPrefix);
            return JSON.parse(str);
        }
    } catch (e) {
        logger.warn({e}, `parse${logPrefix} error`);
        return null;
    }
}

function convertUrlCollection(collection) {
    const baseCollection = {
        id: collection.id || uuidv4(),
        type: collection.type || 'set',
        name: collection.name,
        description: collection.description || '',
        enabled: true,
        visible: true,
        node_encoding: {
            type: collection.node_color ? 'fill' : 'passthrough',
            color: collection.node_color || '#FFFFFF'
        },
        edge_encoding: {
            type: collection.edge_color ? 'fill' : 'passthrough',
            color: collection.edge_color || '#FFFFFF'
        }
    };

    switch(collection.type) {
        case 'intersection':
            return {
                ...baseCollection,
                name: collection.name || 'Untitled Intersection',
                type: 'intersection',
                expr: collection.expr
            };

        case 'set':
            return {
                ...baseCollection,
                name: collection.name || 'Untitled Set',
                type: 'set',
                expr: collection.expr
            };

        default:
            logger.error(`Invalid collection type ${collection.type} in:\n${collection}`)
            return {
                ...baseCollection,
                name: 'Invalid Collection',
                type: 'no_op'
            };
    }
}

export function collections(view, options) {
    options = options.vizClientParams || {};

    const urlCollections = decodeUrlEncodedObj(options.collections, 'collections');
    const globalNodeColor = options.collectionsGlobalNodeColor;
    const globalEdgeColor = options.collectionsGlobalEdgeColor;

    let setsList = [];
    if (urlCollections && Array.isArray(urlCollections)) {
        urlCollections.forEach(collection => setsList.push(convertUrlCollection(collection)));
    }

    setsList.push({
        id: 'global',
        type: 'global',
        name: 'Global Nodes & Edges',
        description: '',
        enabled: true,
        visible: true,
        node_encoding: {
            type: globalNodeColor ? 'fill' : 'passthrough',
            color: globalNodeColor ? `#${globalNodeColor}` : '#999999'
        },
        edge_encoding: {
            type: globalEdgeColor ? 'fill' : 'passthrough',
            color: globalEdgeColor ? `#${globalEdgeColor}` : '#999999'
        }
    });

    return {
        collections: {
            id: 'collections',
            name: 'Collections',
            enabled: true,
            visible: opt(options, 'showCollections', Boolean, false),
            lock_order: false,
            length: setsList.filter(s => s.type !== 'global').length,
            sets: {
                length: setsList.length,
                ...setsList.reduce((acc, set, index) => {
                    acc[index] = set;
                    return acc;
                }, {})
            },
            controls: {
                length: 1,
                0: {
                    id: 'toggle-collections',
                    name: 'Collections',
                    type: 'settings',
                    enabled: true,
                    selected: false,
                    items: $ref(`${view}.collections`)
                }
            }
        }
    };
} 